const GForms = {
  init: function (smoothScroll) {
    const forms = document.querySelectorAll('.gform_wrapper form');
    if (forms?.length >= 1) {
      document.addEventListener('gform_post_render', updateScrollHeight());
    }

    function updateScrollHeight() {
      setTimeout(() => {
        smoothScroll.update();
      }, 500)
    }

  },
};

export default GForms;

